module.exports = __webpack_public_path__ + "static/media/download_large.abbcad6b.svg";